<template>
  <div class="section9">
    <!-- 
   -->
    <div class="bg">
    <img src="./s9/bg.webp" data-aos="fade" />
   </div>
      <mimg class="img absolute" />


    <div class="txt">
<svg @init="init" class="logo" data-aos="zoom-in" data-aos-delay="200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 642 258">
<path class="st0" d="M56.1,49.9c1.1-9.4-5.1-29.5-45.3-38.1l-3.9,3.9C18.9,26,29,44,30.8,58.9C40.5,69.4,54.7,62.2,56.1,49.9z
	 M155.4,31c3.6,0.7,8.9-1.1,10.2-6.2l-32.2-14.8c-7.4,19.3-17.2,40.7-25.3,54.5l4.9,4C125.1,61.3,143.5,44.4,155.4,31z M29.8,69.1
	L4.3,58.7V194c20.3,0,25.5-7.7,25.5-10.3V69.1z M109.8,167.2v6.8c16.6,0.9,23,6.5,21.9,20.5c24.9-1.9,32.8-9.6,32.8-27.5V82.4
	c5-1.5,6.9-3.2,9.5-6L147.3,57l-9.4,12.1H96.3V15.7c5.9-1,8.5-3.8,8.6-9L70.6,3.3v65.9h-36v8.4h104.1v89.8H109.8z M68.9,98.3
	l-23.5-9.8V171l0,0c15.5,1.3,23.5-5.2,23.5-9.1V98.3z M122,110.9c4.4-1.2,7-3.3,9.4-6.3l-25.6-17.9l-8.6,11.1H74v8.4h24.1v37.4H74
	v8.4h24.1v13.9c12.4,0.9,23.9-4.2,23.9-8.2V110.9z M369.2,75.6h-23.4V84h12v110c9.6,1.1,25.2-3,25.3-8V84h11.1
	c5.1,0.2,10.3-1.2,12.7-6.1l-25.3-19.5L369.2,75.6L369.2,75.6z M301.6,39.8c6.4,0.1,10.1-1.3,12.2-6.2L292,17.3l-10.4,14.4h-6.2
	V14.9c5.6-0.8,8.3-3.7,8.5-8.8l-33.1-3.2v36.9H301.6z M225,34c8.6,10.6,10.6,29.1,9.2,40.6c0.6,1.1,1.4,2.2,2.2,3h-24.5L214,86h36.5
	v22.4h-36.2l2.1,8.4h28.1c-7.6,22.5-19.4,42.9-33.5,57.5l4.6,5.8c13.3-8.1,25.1-17.9,34.9-29.1V194c16.3,1.2,25.9-6.4,24.7-8.3
	c0,0,0-51.1,0-51.1c5.5,7,9.4,15.5,10.2,22.7c5.8,7.5,17.9,6.5,21.3-3c3.1-8.8-1.7-23.5-31.5-29.9l0,0v-7.7h28
	c5.7,0.1,9.9-1.6,12.3-6.3l-21.3-16.5l-10.4,14.4h-8.6V88.3c1.5-0.3,3.4-0.9,4.6-2.3h26.4c4.2,0,7.5-0.5,9.7-2.6
	c0.7,68.7-15.3,87.4-32.3,105.9l5.1,5.1C330,171.7,341,136.5,341,88.7V36.8c16.5-2.1,35-6.1,48.3-10.3c7.6,2.2,11.2,1.1,14.8-3.1
	l-26-20.7c-8.9,7.7-23.3,16.8-37.7,23.9l-24.5-7.8v59.1l-19.5-13.7l-10.6,13.5h-6.6c6.8-8.1,14.1-18.1,19.5-26.5
	c3.8,0.3,8.4-1.7,8.9-7l-31.3-7.4c-1.6,10.4-4.9,29-7.8,40.9h-15.2C269.2,58.8,240.7,38.5,225,34z M244.8,39.8v-8.2h-29.5l2.2,8.2
	H244.8z M624.2,23.3l1.1-1.7L602,4.2l-11.4,15.4h-42.7v8.4h64.9C617,27.9,621.7,27.4,624.2,23.3L624.2,23.3z M573.7,165.5
	c8,11.9,18.8,22.7,33.6,30.2c1.1-11.1,7.9-19.9,19.5-24.5l0.5-5.2c-14.5-4.5-25.1-11-37-20.4C585.8,152.5,580.1,159.1,573.7,165.5z
	 M491.5,190.8l5.4,4.1c39-30.3,45.6-77.9,46.1-115.8h2.5c3.6,26.2,8.9,47.1,16.1,64c-11.9,18.6-28.1,33.6-47.7,44.5l3.1,6.7
	c47.1-16.9,82.6-53.2,95.9-109.8c4.4-0.5,7.2-2.1,9-5.8L598.5,58L586,70.9h-43V19l-24.9-9.1l0,60.6l0,0
	C518.1,138.2,506.8,167.5,491.5,190.8z M490,82.9V60.4h20.2c3.1,0,11.4-0.6,11.4-6.9l-21.2-16.7L490,51.5V15.4
	c5.2-0.5,8.5-3.6,8.1-8.9l-33.2-3.2v48.8h-31.8l2.1,8.4h27.5c-4,23.8-13,57.2-31.6,82.6l5.3,5.6c10.9-9.3,20.5-19.9,28.6-32V194
	c16.5,1.1,25.1-4.8,25.1-8.6V96.6c3.2,7.1,5.4,15,5.5,21.9C511.5,139.3,542.9,102.7,490,82.9z M554.3,79.1h31.5
	c-3,16.1-7.6,31-13.6,44.4C564.4,111.2,558.4,96.3,554.3,79.1L554.3,79.1z"/>
<path class="st1" d="M184.3,235.9h6.1c0.6,1.5-0.2,1.7-1.5,1.6l0.4,17.6h1.5c0.2,0.6,0.4,1.6-0.5,1.6c0,0-5.9,0-5.9,0
	c-0.6-1.5,0-1.7,1.4-1.6l-0.1-16.1c-1,3.8-3.5,12.1-4.8,14.9c-0.3,1.1-3.1,0.9-3.4,0.7l-5.3-15.7l0.1,16.2h1.4
	c0.2,0.6,0.4,1.6-0.5,1.6c0,0-5.6,0-5.6,0c-0.6-1.7,0.3-1.6,1.6-1.6l0.4-17.6H168c-0.2-0.6-0.4-1.6,0.5-1.6l6.3,0l4.9,15.9
	L184.3,235.9z M194,247.3c-0.5-13.7,17.3-16.8,17.9-2.1C212.5,259.1,194.6,262,194,247.3z M197.8,245.9
	c-0.2,11.2,10.3,11.9,10.5,0.7C208.5,235.5,198,234.9,197.8,245.9z M215.9,235.9c7.8-0.1,16.9-2,16.9,9.4c0,12.6-8.3,11.8-17.4,11.3
	c-0.7-1.5,0.4-1.7,1.6-1.6c0.1-1.2,0.2-14.4,0-17.6h-1.6C215.2,236.9,215,235.9,215.9,235.9L215.9,235.9z M220.6,238.3
	c0.1,0.1-0.5,12.8,0.3,15.6c0.3,0.4,8.2,3.2,8.2-7.5C229.1,235.9,220.6,238.3,220.6,238.3z M237.9,237.5h-1.6
	c-0.2-0.6-0.4-1.6,0.5-1.6h13c2-0.2,1.7,1.9,0.9,3.1c-2-0.9-5.9-1.3-9.2-1.2v6.8h7.8c0.2,0.7,0.6,2.1-0.5,2c0,0-7.3,0-7.3,0v8
	c3.2,0.1,7.6-0.1,9.7-1.1c0.9,1.6,0.6,3.3-1.8,3c0,0-13.2,0-13.2,0c-0.7-1.5,0.4-1.7,1.6-1.6V237.5z M259.9,255.1L259.9,255.1l2.2,0
	c0.2,0.6,0.4,1.6-0.5,1.6c0,0-7.1,0-7.1,0c-0.8-1.7,0.6-1.6,1.9-1.6v-17.6h-1.8c-0.2-0.6-0.4-1.6,0.5-1.6c0,0,9.2,0,9.2,0
	c6,0,9.5,8.4,0.8,11c4,0.6,3.6,8,7.4,8.1c1.2,2.7-3.6,1.9-4.6,1.4c-2.2-2.7-2.4-10.4-8.1-8.4L259.9,255.1z M259.8,246
	c9,1.4,8.7-9.5,0.1-7.7C259.8,238.9,259.8,243.5,259.8,246z M289.6,252.7v-15.2h-1.6c-0.2-0.6-0.5-1.6,0.5-1.6c0,0,5.7,0,5.7,0
	c0.7,1.6-0.5,1.7-1.7,1.6v18c0,2.1-3.3,1.3-3.8,1.2l-9.3-15.9v14.4h1.5c0.2,0.6,0.4,1.6-0.5,1.6c0,0-5.6,0-5.6,0
	c-0.7-1.7,0.5-1.6,1.8-1.6l0-17.6h-1.4c-0.2-0.6-0.5-1.6,0.5-1.6l4.8,0L289.6,252.7z M322.1,235.9h6.1c0.6,1.5-0.2,1.7-1.5,1.6
	l0.4,17.6h1.5c0.2,0.6,0.4,1.6-0.5,1.6c0,0-5.9,0-5.9,0c-0.6-1.5,0-1.7,1.4-1.6l-0.1-16.1c-1,3.8-3.5,12.1-4.8,14.9
	c-0.3,1.1-3.1,0.9-3.4,0.7l-5.3-15.7l0.1,16.2h1.4c0.2,0.6,0.4,1.6-0.5,1.6c0,0-5.6,0-5.6,0c-0.6-1.7,0.3-1.6,1.6-1.6l0.4-17.6h-1.5
	c-0.2-0.6-0.4-1.6,0.5-1.6l6.3,0l4.9,15.9L322.1,235.9z M350.5,255.1h1.3c0.2,0.6,0.4,1.6-0.5,1.6c0,0-6.3,0-6.3,0
	c-0.6-1.3,0.1-1.7,1.3-1.6c-0.2-0.9-0.7-2.6-1.5-5.2H338c-0.7,2.5-1.1,4.3-1.3,5.2h1.4c0.2,0.6,0.4,1.6-0.5,1.6c0,0-5.6,0-5.6,0
	c-0.6-1.4,0.1-1.7,1.4-1.6l6.2-18.3c0.8-1.8,3.8-1.1,3.9-1L350.5,255.1z M338.5,248h5.7C340.2,236.3,342.3,236.2,338.5,248z
	 M370.3,252.7v-15.2h-1.6c-0.2-0.6-0.5-1.6,0.5-1.6c0,0,5.7,0,5.7,0c0.7,1.6-0.5,1.7-1.7,1.6v18c0,2.1-3.3,1.3-3.8,1.2l-9.3-15.9
	v14.4h1.5c0.2,0.6,0.4,1.6-0.5,1.6c0,0-5.6,0-5.6,0c-0.7-1.7,0.5-1.6,1.8-1.6l0-17.6h-1.4c-0.2-0.6-0.5-1.6,0.5-1.6l4.8,0
	L370.3,252.7z M387.6,235.6c3.4,0.1,7.7,0.3,5,3.7c-5.6-2.8-10.1-1.6-9.1,2.3c0.9,3.6,10.4,2.6,10.7,9.1c0.4,10-19.1,6.2-13.7,2.3
	c6.4,3.5,11.9,1.1,10.1-2.8c-1.1-2.5-7.7-3-9.6-5.3C377.5,240.5,381.9,235.5,387.6,235.6z M399.7,235.9h6.8c0.8,1.7-0.7,1.6-1.9,1.6
	c-0.2,3.1-0.1,16.4,0,17.6h1.9c0.2,0.6,0.4,1.6-0.5,1.6c0,0-6.8,0-6.8,0c-0.8-1.7,0.6-1.6,1.9-1.6c0.1-1.1,0.2-14.4,0-17.6h-1.9
	C399,236.9,398.8,235.9,399.7,235.9z M411.5,247.3c-0.5-13.7,17.3-16.8,17.9-2.1C430,259.1,412.1,262,411.5,247.3z M415.2,245.9
	c-0.2,11.2,10.3,11.9,10.5,0.7C426,235.5,415.5,234.9,415.2,245.9z M449.3,252.7v-15.2h-1.6c-0.2-0.6-0.5-1.6,0.5-1.6
	c0,0,5.7,0,5.7,0c0.7,1.6-0.5,1.7-1.7,1.6v18c0,2.1-3.3,1.3-3.8,1.2l-9.3-15.9v14.4h1.5c0.2,0.6,0.4,1.6-0.5,1.6c0,0-5.6,0-5.6,0
	c-0.7-1.7,0.5-1.6,1.8-1.6l0-17.6h-1.4c-0.2-0.6-0.5-1.6,0.5-1.6l4.8,0L449.3,252.7z"/>
<path class="st2" d="M142.5,247.8H0.5"/>
<path class="st2" d="M631,247.8H468.7"/>
</svg>

<div class="t1" data-aos="zoom-in" data-aos-delay="400">捷運府中站｜壓軸45坪｜挑高3米6</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/function.scss';

.section9 {
  width: 100%;
  height: size(900);
  // overflow: hidden;
  position: relative;z-index: 1; 
  background: #870004;
  //background: radial-gradient(55% 80% at 50% 30%, #FF9093 2%, #E75B6F 19%, #C91944 60%, #BE0033 84%,);

  // background: url("./s1/bg.jpg") center;
  // background-size: 100% auto;
//  background: #40210D;
}
/*
.bg{
  position: absolute;
  width:size(3700);
  top:size(-800);
  right:size(-450);filter: blur(2px);
  img{width: 100%;
  transform: rotate(20deg)scale(.8)translateX(10%);}
}
*/
.bg{
  position: absolute;width: 100%;top: 0;left: 0;
  img{width: 100%;}
}
.img{
  width:size(1068);left: size(-200);top:size(40);
  margin: 0 auto 0em;opacity: .59;
}

.txt{
  position: relative;
  // top:calc(50% + (253 - 540) * 100vw / 1920);
 //  left:size(-260);
  top:size(320);
  font-size: size(54);
  line-height: 1.5;
  color: #fff;
  text-align: center;
  width:size(1920);
    letter-spacing:0em;
    padding: 0;
  font-weight: 900;
  margin: auto auto auto auto;

  //filter: drop-shadow(0 0 7px #eff);

  .logo{
  width:size(630);
	.st0{fill:#FFF;filter: drop-shadow(6px 6px 8px rgba(0, 0, 0, 0.8));}
	.st1{fill:#FFF;}
	.st2{fill:none;stroke:#FFF;stroke-width:1;}
}
  
.t1{
    display: block;
  font-size: 1em;
    letter-spacing:0.07em;
  margin: -0.1em 0 0 0 ;
    }

}
/* 螢幕尺寸標準 */
/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
}

@media screen and (max-width: 767px) {
  .section9 {
  height: sizem(460);
  }
.bg{width: 120%;top: 0;left:-10%;
  img{width: 100%;}
}
  
  /*
.bg{
  width:sizem(1175);
  top:sizem(-300);
  right:sizem(-190);
  transform: scaleY(-1);
  img{}
}*/
.img{
  width:sizem(198);left: sizem(88);top:sizem(75);
  margin: 0 auto 0em;opacity: 1;
}

.txt{
  font-size: sizem(18);
  top:sizem(300);
  width:sizem(300);
.logo{
  width:sizem(200);
}
}
}
</style>
<script>
// @ is an alias to /src
import info from '@/info'
import { isPC, isMobile, isTablet } from '@/utils'
import mimg from './m.vue'

export default {
  name: 'section9',
  components: {},

  props: ['title', 'cls'],
  components: {
    mimg,
  },

  data() {
    return {
      info,
      isPC,
      isMobile,
      isTablet,
    }
  },

  methods: {
    init() {},},

  mounted() {},

  created() {},

  computed: {},
}
</script>
